/* eslint-disable max-len */
import React from 'react'

const ratio = 123 / 51
export default function BlueLightTiles({ className = undefined, height = 51 }) {
  return (
    <svg
      id="ewyrIcXMNqf1"
      className={className}
      width={height * ratio}
      height={height}
      viewBox="0 0 123 51"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
    >
      <g transform="translate(42.470001 0)">
        <polygon
          id="ewyrIcXMNqf3"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(-.127478-.149433)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#cceffc" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="ewyrIcXMNqf8"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="ewyrIcXMNqf9"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="ewyrIcXMNqf10"
            points="36.6,10.5 36.6,7.5 19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(63.703999 8.148)">
        <polygon
          id="ewyrIcXMNqf12"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.3,10.8 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#cceffc" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="ewyrIcXMNqf17"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="ewyrIcXMNqf18"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="ewyrIcXMNqf19"
            points="19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7 36.6,10.5 36.6,7.5"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(21.235001 8.148)">
        <polygon
          id="ewyrIcXMNqf21"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#cceffc" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="ewyrIcXMNqf26"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="ewyrIcXMNqf27"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="ewyrIcXMNqf28"
            points="22.7,2.4 19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7 36.6,10.5 36.6,8.3 36.6,7.5"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(84.938004 16.296)">
        <polygon
          id="ewyrIcXMNqf30"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.4,10.9 19,4.7 36.6,11.2"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#cceffc" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="ewyrIcXMNqf35"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(0-.127478)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="ewyrIcXMNqf36"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="ewyrIcXMNqf37"
            points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 15.3,16.4 15.3,15.7 1.5,10.5"
            transform="translate(-.127479 0)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(42.420002 16.296)">
        <polygon
          id="ewyrIcXMNqf39"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.127478 0)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#cceffc" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="ewyrIcXMNqf44"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(-.117366 0)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="ewyrIcXMNqf45"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="ewyrIcXMNqf46"
            points="1.5,7.5 19,1 36.6,7.5 36.6,10.5 22.7,15.7 22.7,16.4 19.7,17.5 19,17.3 18.4,17.5 15.3,16.4 15.3,15.7 1.5,10.5"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(0 16.296)">
        <polygon
          id="ewyrIcXMNqf48"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.117366 0)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="1.5,11.2 1.5,11.2 19,4.7 35.6,10.9"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#cceffc" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="ewyrIcXMNqf53"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(.127479 0)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="ewyrIcXMNqf54"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="ewyrIcXMNqf55"
            points="1.5,7.5 19,1 36.6,7.5 36.6,10.5 22.7,15.7 22.7,16.4 19,17.8 1.5,11.2"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(63.703999 24.444)">
        <polygon
          id="ewyrIcXMNqf57"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(0 0.127479)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.3,10.8 19,4.7 36.6,11.2"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#cceffc" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="ewyrIcXMNqf62"
            points="1.5,7.6 19,14.1 36.6,7.6"
            transform="translate(-.146131-.127478)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="ewyrIcXMNqf63"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="ewyrIcXMNqf64"
            points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 15.3,16.4 15.3,15.7 1.5,10.5"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(21.235001 24.444)">
        <polygon
          id="ewyrIcXMNqf66"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.127479-.117366)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="1.5,11.2 1.5,11.2 19,4.7 35.6,10.9"
            transform="translate(.117367 0)"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#cceffc" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="ewyrIcXMNqf71"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="ewyrIcXMNqf72"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="ewyrIcXMNqf73"
            points="1.5,7.6 19,1 36.6,7.6 36.6,10.5 22.7,15.7 22.7,16.4 19,17.8 1.5,11.2"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(42.470001 32.592999)">
        <polygon
          id="ewyrIcXMNqf75"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(0 0.117366)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.1"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="1.5,11.2 1.5,11.2 19,4.7 36.6,11.2"
            fill="none"
            stroke="#cceffc"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#cceffc" strokeWidth="0.6" />
        </g>
        <g>
          <line
            id="ewyrIcXMNqf80"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polyline
            id="ewyrIcXMNqf81"
            points="1.5,7.5 19,14.1 36.6,7.5"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="ewyrIcXMNqf82"
            points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <style>{`#ewyrIcXMNqf3 {animation: ewyrIcXMNqf3_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf3_f_p { 0% {fill: none} 2.941176% {fill: none} 5.882353% {fill: #00abe8} 14.705882% {fill: #00abe8} 17.647059% {fill: none} 55.882353% {fill: none} 58.823529% {fill: #00abe8} 67.647059% {fill: #00abe8} 70.588235% {fill: none} 73.529412% {fill: none} 76.470588% {fill: #00abe8} 85.294118% {fill: #00abe8} 88.235294% {fill: none} 100% {fill: none}} #ewyrIcXMNqf8 {animation: ewyrIcXMNqf8_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf8_s_p { 0% {stroke: #82d4f2} 2.941176% {stroke: #82d4f2} 5.882353% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 58.823529% {stroke: #00abe8} 61.764706% {stroke: #00abe8} 64.705882% {stroke: #82d4f2} 73.529412% {stroke: #82d4f2} 76.470588% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf9 {animation: ewyrIcXMNqf9_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf9_s_p { 0% {stroke: #82d4f2} 2.941176% {stroke: #82d4f2} 5.882353% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 58.823529% {stroke: #00abe8} 61.764706% {stroke: #00abe8} 64.705882% {stroke: #82d4f2} 73.529412% {stroke: #82d4f2} 76.470588% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf10 {animation: ewyrIcXMNqf10_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf10_s_p { 0% {stroke: #82d4f2} 2.941176% {stroke: #82d4f2} 5.882353% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 58.823529% {stroke: #00abe8} 61.764706% {stroke: #00abe8} 64.705882% {stroke: #82d4f2} 73.529412% {stroke: #82d4f2} 76.470588% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf12 {animation: ewyrIcXMNqf12_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf12_f_p { 0% {fill: none} 2.941176% {fill: none} 5.882353% {fill: #00abe8} 14.705882% {fill: #00abe8} 17.647059% {fill: none} 50% {fill: none} 52.941176% {fill: #00abe8} 61.764706% {fill: #00abe8} 64.705882% {fill: none} 79.411765% {fill: none} 82.352941% {fill: #00abe8} 88.235294% {fill: #00abe8} 91.176471% {fill: #00abe8} 94.117647% {fill: none} 100% {fill: none}} #ewyrIcXMNqf17 {animation: ewyrIcXMNqf17_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf17_s_p { 0% {stroke: #82d4f2} 2.941176% {stroke: #82d4f2} 5.882353% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 55.882353% {stroke: #00abe8} 58.823529% {stroke: #82d4f2} 61.764706% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf18 {animation: ewyrIcXMNqf18_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf18_s_p { 0% {stroke: #82d4f2} 2.941176% {stroke: #82d4f2} 5.882353% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 55.882353% {stroke: #00abe8} 58.823529% {stroke: #82d4f2} 61.764706% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf19 {animation: ewyrIcXMNqf19_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf19_s_p { 0% {stroke: #82d4f2} 2.941176% {stroke: #82d4f2} 5.882353% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 55.882353% {stroke: #00abe8} 58.823529% {stroke: #82d4f2} 61.764706% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf21 {animation: ewyrIcXMNqf21_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf21_f_p { 0% {fill: none} 8.823529% {fill: none} 11.764706% {fill: #00abe8} 14.705882% {fill: #00abe8} 20.588235% {fill: #00abe8} 23.529412% {fill: none} 50% {fill: none} 52.941176% {fill: #00abe8} 61.764706% {fill: #00abe8} 64.705882% {fill: none} 73.529412% {fill: none} 76.470588% {fill: #00abe8} 85.294118% {fill: #00abe8} 88.235294% {fill: none} 100% {fill: none}} #ewyrIcXMNqf26 {animation: ewyrIcXMNqf26_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf26_s_p { 0% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 55.882353% {stroke: #00abe8} 58.823529% {stroke: #82d4f2} 61.764706% {stroke: #82d4f2} 73.529412% {stroke: #82d4f2} 76.470588% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf27 {animation: ewyrIcXMNqf27_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf27_s_p { 0% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 55.882353% {stroke: #00abe8} 58.823529% {stroke: #82d4f2} 61.764706% {stroke: #82d4f2} 73.529412% {stroke: #82d4f2} 76.470588% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf28 {animation: ewyrIcXMNqf28_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf28_s_p { 0% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 55.882353% {stroke: #00abe8} 58.823529% {stroke: #82d4f2} 61.764706% {stroke: #82d4f2} 73.529412% {stroke: #82d4f2} 76.470588% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf30 {animation: ewyrIcXMNqf30_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf30_f_p { 0% {fill: none} 2.941176% {fill: none} 5.882353% {fill: #00abe8} 14.705882% {fill: #00abe8} 17.647059% {fill: none} 44.117647% {fill: none} 47.058824% {fill: #00abe8} 55.882353% {fill: #00abe8} 58.823529% {fill: none} 85.294118% {fill: none} 88.235294% {fill: #00abe8} 91.176471% {fill: #00abe8} 97.058824% {fill: #00abe8} 100% {fill: none}} #ewyrIcXMNqf35 {animation: ewyrIcXMNqf35_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf35_s_p { 0% {stroke: #82d4f2} 2.941176% {stroke: #82d4f2} 5.882353% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 91.176471% {stroke: #00abe8} 94.117647% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf36 {animation: ewyrIcXMNqf36_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf36_s_p { 0% {stroke: #82d4f2} 2.941176% {stroke: #82d4f2} 5.882353% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 91.176471% {stroke: #00abe8} 94.117647% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf37 {animation: ewyrIcXMNqf37_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf37_s_p { 0% {stroke: #82d4f2} 2.941176% {stroke: #82d4f2} 5.882353% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 91.176471% {stroke: #00abe8} 94.117647% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf39 {animation: ewyrIcXMNqf39_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf39_f_p { 0% {fill: none} 8.823529% {fill: none} 11.764706% {fill: #00abe8} 14.705882% {fill: #00abe8} 20.588235% {fill: #00abe8} 23.529412% {fill: none} 44.117647% {fill: none} 47.058824% {fill: #00abe8} 55.882353% {fill: #00abe8} 58.823529% {fill: none} 79.411765% {fill: none} 82.352941% {fill: #00abe8} 88.235294% {fill: #00abe8} 91.176471% {fill: #00abe8} 94.117647% {fill: none} 100% {fill: none}} #ewyrIcXMNqf44 {animation: ewyrIcXMNqf44_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf44_s_p { 0% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf45 {animation: ewyrIcXMNqf45_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf45_s_p { 0% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf46 {animation: ewyrIcXMNqf46_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf46_s_p { 0% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf48 {animation: ewyrIcXMNqf48_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf48_f_p { 0% {fill: none} 14.705882% {fill: none} 17.647059% {fill: #00abe8} 26.470588% {fill: #00abe8} 29.411765% {fill: none} 44.117647% {fill: none} 47.058824% {fill: #00abe8} 55.882353% {fill: #00abe8} 58.823529% {fill: none} 73.529412% {fill: none} 76.470588% {fill: #00abe8} 85.294118% {fill: #00abe8} 88.235294% {fill: none} 100% {fill: none}} #ewyrIcXMNqf53 {animation: ewyrIcXMNqf53_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf53_s_p { 0% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 20.588235% {stroke: #00abe8} 23.529412% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 73.529412% {stroke: #82d4f2} 76.470588% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf54 {animation: ewyrIcXMNqf54_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf54_s_p { 0% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 20.588235% {stroke: #00abe8} 23.529412% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 73.529412% {stroke: #82d4f2} 76.470588% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf55 {animation: ewyrIcXMNqf55_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf55_s_p { 0% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 20.588235% {stroke: #00abe8} 23.529412% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 73.529412% {stroke: #82d4f2} 76.470588% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf57 {animation: ewyrIcXMNqf57_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf57_f_p { 0% {fill: none} 8.823529% {fill: none} 11.764706% {fill: #00abe8} 14.705882% {fill: #00abe8} 20.588235% {fill: #00abe8} 23.529412% {fill: none} 38.235294% {fill: none} 41.176471% {fill: #00abe8} 47.058824% {fill: #00abe8} 50% {fill: #00abe8} 52.941176% {fill: none} 85.294118% {fill: none} 88.235294% {fill: #00abe8} 91.176471% {fill: #00abe8} 97.058824% {fill: #00abe8} 100% {fill: none}} #ewyrIcXMNqf62 {animation: ewyrIcXMNqf62_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf62_s_p { 0% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 38.235294% {stroke: #82d4f2} 41.176471% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 91.176471% {stroke: #00abe8} 94.117647% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf63 {animation: ewyrIcXMNqf63_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf63_s_p { 0% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 38.235294% {stroke: #82d4f2} 41.176471% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 91.176471% {stroke: #00abe8} 94.117647% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf64 {animation: ewyrIcXMNqf64_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf64_s_p { 0% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 38.235294% {stroke: #82d4f2} 41.176471% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 91.176471% {stroke: #00abe8} 94.117647% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf66 {animation: ewyrIcXMNqf66_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf66_f_p { 0% {fill: none} 14.705882% {fill: none} 17.647059% {fill: #00abe8} 26.470588% {fill: #00abe8} 29.411765% {fill: none} 38.235294% {fill: none} 41.176471% {fill: #00abe8} 47.058824% {fill: #00abe8} 50% {fill: #00abe8} 52.941176% {fill: none} 79.411765% {fill: none} 82.352941% {fill: #00abe8} 88.235294% {fill: #00abe8} 91.176471% {fill: #00abe8} 94.117647% {fill: none} 100% {fill: none}} #ewyrIcXMNqf71 {animation: ewyrIcXMNqf71_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf71_s_p { 0% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 20.588235% {stroke: #00abe8} 23.529412% {stroke: #82d4f2} 38.235294% {stroke: #82d4f2} 41.176471% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf72 {animation: ewyrIcXMNqf72_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf72_s_p { 0% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 20.588235% {stroke: #00abe8} 23.529412% {stroke: #82d4f2} 38.235294% {stroke: #82d4f2} 41.176471% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf73 {animation: ewyrIcXMNqf73_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf73_s_p { 0% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 20.588235% {stroke: #00abe8} 23.529412% {stroke: #82d4f2} 38.235294% {stroke: #82d4f2} 41.176471% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf75 {animation: ewyrIcXMNqf75_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf75_f_p { 0% {fill: none} 14.705882% {fill: none} 17.647059% {fill: #00abe8} 26.470588% {fill: #00abe8} 29.411765% {fill: none} 32.352941% {fill: none} 35.294118% {fill: #00abe8} 38.235294% {fill: #00abe8} 44.117647% {fill: #00abe8} 47.058824% {fill: none} 85.294118% {fill: none} 88.235294% {fill: #00abe8} 97.058824% {fill: #00abe8} 100% {fill: none}} #ewyrIcXMNqf80 {animation: ewyrIcXMNqf80_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf80_s_p { 0% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 20.588235% {stroke: #00abe8} 23.529412% {stroke: #82d4f2} 32.352941% {stroke: #82d4f2} 35.294118% {stroke: #00abe8} 38.235294% {stroke: #00abe8} 41.176471% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 91.176471% {stroke: #00abe8} 94.117647% {stroke: #82d4f2} 97.058824% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf81 {animation: ewyrIcXMNqf81_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf81_s_p { 0% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 20.588235% {stroke: #00abe8} 23.529412% {stroke: #82d4f2} 32.352941% {stroke: #82d4f2} 35.294118% {stroke: #00abe8} 38.235294% {stroke: #00abe8} 41.176471% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 91.176471% {stroke: #00abe8} 94.117647% {stroke: #82d4f2} 97.058824% {stroke: #82d4f2} 100% {stroke: #82d4f2}} #ewyrIcXMNqf82 {animation: ewyrIcXMNqf82_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes ewyrIcXMNqf82_s_p { 0% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 20.588235% {stroke: #00abe8} 23.529412% {stroke: #82d4f2} 32.352941% {stroke: #82d4f2} 35.294118% {stroke: #00abe8} 38.235294% {stroke: #00abe8} 41.176471% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 91.176471% {stroke: #00abe8} 94.117647% {stroke: #82d4f2} 97.058824% {stroke: #82d4f2} 100% {stroke: #82d4f2}}`}</style>
    </svg>
  )
}
